import { configureStore } from "@reduxjs/toolkit";
import reducers from "../reducers";
import { createLogger } from "redux-logger";
import { persistStore } from "redux-persist";

const logger = createLogger({ predicate: () => false });

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(logger),
});

export const persistor = persistStore(store);
